let toastr = {
	maxAnimationDelay: 2000,
	preventDuplicates: false,
};

export default toastr;
